import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kehulianxiren",
  "use": "icon-kehulianxiren-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"icon-kehulianxiren\"><path d=\"M7.141 0c3.248 0 5.88 2.344 5.88 5.236 0 2.024-1.29 3.78-3.177 4.652 2.45.968 4.158 3.154 4.158 5.696 0 .14-.005.278-.015.415h-1.411l.003-.02c.015-.132.023-.264.023-.395 0-2.504-2.789-4.987-5.601-4.987s-5.6 2.483-5.6 4.987c0 .138.008.277.024.415H.015A5.636 5.636 0 010 15.585c0-2.595 1.78-4.819 4.312-5.758-1.819-.889-3.052-2.611-3.052-4.59C1.26 2.344 3.893 0 7.141 0zm0 1.122c-2.32 0-4.62 2.048-4.62 4.114S4.82 9.35 7.14 9.35c2.32 0 4.62-2.048 4.62-4.114s-2.3-4.114-4.62-4.114z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/kehulianxiren.svg
// module id = 485
// module chunks = 4